@use '../../styling/colors.scss' as *;
@use '../../styling/typography.scss' as *;

.InvisiButton {
  @extend %font-family-primary;

  background: $theme-color-background;
  border: 0;
  display: inline-flex;
  border-radius: 6px;
  cursor: pointer;
  font-size: $font-size-normal;
  font-weight: $font-weight-semibold;
  color: $theme-color-text;
  height: 100%;
  max-height: 32px;
  align-items: center;
  padding: 1px 4px;

  &:disabled {
    color: $theme-color-button-remove-chip;
    pointer-events: none;
    opacity: 0.3;
  }

  &.HasHoverEffect {
    background: $theme-invisi-clear-button-color;

    &:hover {
      background-color: $theme-color-secondary-button-hover;
      border-radius: 6px;
    }

    &:active {
      background-color: $theme-color-secondary-button-active;
    }
  }

  &.NoPadding {
    padding: 0;
  }

  &.NoBackgroundColor {
    background: $color-transparent;
  }
}
